import _regeneratorRuntime from "/app/node_modules/babel-runtime/regenerator";
import _asyncToGenerator from "/app/node_modules/babel-runtime/helpers/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { required, decimal, minValue } from "vuelidate/lib/validators";
import loader from "~/components/modals/loader";
export default {
  props: ["idTariff"],
  components: {
    loader: loader
  },
  data: function data() {
    return {
      sending: false,
      platforms: ["Autoafiliacion", "Herramienta de Afiliación"],
      channels: [],
      subproducts: ["Pago Web", "Pago App", "Pago Link", "POS Fijo Internet Alquiler", "POS Fijo Internet Alquiler (Grifos)", "POS Inalámbrico Alquiler", "POS Inalámbrico Alquiler (Grifos)", "POS Inalámbrico Venta Básica", "POS Inalámbrico Venta Extendida"],
      currencies: ["Soles", "Dolares"],
      namePlatform: "Autoafiliacion",
      selecyCoinBy: ["POS Fijo Internet Alquiler (Grifos)", "POS Inalámbrico Alquiler (Grifos)", "POS Inalámbrico Venta Extendida"],

      platform: "",
      channel: "",
      switchChannel: true,
      selectChannel: false,

      subproduct: "",
      currency: "",

      affiliation: "",
      switchAffiliation: true,
      selectAffiliation: false,

      affiliationComment: "",
      switchAffiliationComment: true,
      selectAffiliationComment: false,

      equipmentCost: "",
      switchEquipmentCost: true,
      selectEquipmentCost: false,

      equipmentCostComment: "",
      switchEquipmentCostComment: true,
      selectEquipmentCostComment: false,

      maintenance: "",
      switchMaintenance: true,
      selectMaintenance: false,

      maintenanceDollar: "",
      switchMaintenanceDollar: true,
      selectMaintenanceDollar: false,

      maintenanceComment: "",
      switchMaintenanceComment: true,
      selectMaintenanceComment: false,

      platformUsageCE: "",
      switchPlatformUsageCE: true,
      selectPlatformUsageCE: false,

      platformUsageCEComment: "",
      switchPlatformUsageCEComment: true,
      selectPlatformUsageCEComment: false,

      renewal: "",
      switchRenewal: true,
      selectRenewal: false,

      renewalComment: "",
      switchRenewalComment: true,
      selectRenewalComment: false
    };
  },
  validations: function validations() {
    return {
      platform: { required: required },
      channel: { required: required },
      subproduct: { required: required },
      currency: { required: required }
    };
  },

  methods: {
    prevPage: function prevPage() {
      this.$router.push("/tariff");
    },
    onSubmit: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this = this;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.sending = true;
                this.$refs.loaderModal.showLoader();
                _context.prev = 2;
                _context.next = 5;
                return this.$store.dispatch("master-data/updateTariff", {
                  platform: this.platform,
                  channel: this.channel,
                  subproduct: this.subproduct,
                  currency: this.currency,
                  affiliation: this.affiliation,
                  affiliationComment: this.affiliationComment,
                  equipmentCost: this.equipmentCost,
                  equipmentCostComment: this.equipmentCostComment,
                  maintenance: this.maintenance,
                  maintenanceDollar: this.maintenanceDollar,
                  maintenanceComment: this.maintenanceComment,
                  platformUsageCE: this.platformUsageCE,
                  platformUsageCEComment: this.platformUsageCEComment,
                  renewal: this.renewal,
                  renewalComment: this.renewalComment,
                  idTariff: this.idTariff
                });

              case 5:
                this.dialog = false;
                this.$swal2.fire("Buen trabajo!", "La tarifa se ha actualizado correctamente.", "success").then(function (result) {
                  if (result.isConfirmed) {
                    _this.$router.push("/tariff");
                  }
                });
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](2);

                console.error("Error...", _context.t0);

              case 12:
                this.sending = false;
                this.$refs.loaderModal.closeLoader();

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 9]]);
      }));

      function onSubmit() {
        return _ref.apply(this, arguments);
      }

      return onSubmit;
    }(),
    selectPlatform: function selectPlatform(val) {

      if (val === "Herramienta de Afiliación") {
        this.namePlatform = "Herramienta de Afiliación";
        this.currencies = [];
        this.currencies = ["Soles", "Dolares", "Soles y Dolares"];
        this.subproducts = ["Pago Web", "Pago App", "Pago Link", "POS Fijo Internet Alquiler", "POS Fijo Internet Alquiler (Grifos)", "POS Inalámbrico Alquiler", "POS Inalámbrico Alquiler (Grifos)", "POS Inalámbrico Venta Básica", "POS Inalámbrico Venta Extendida"];
      } else {
        this.currencies = [];
        this.currencies = ["Soles", "Dolares"];
        this.subproducts = ["Pago Web", "Pago App", "Pago Link", "POS Fijo Internet Alquiler", "POS Fijo Internet Venta", "POS Inalámbrico Alquiler", "POS Inalámbrico Venta"];
      }
    },
    selectCoin: function selectCoin(val) {
      //* realizar validacion con autoafiliacion
      if (this.selecyCoinBy.includes(val) || this.namePlatform === "Autoafiliacion") {
        this.currencies = ["Soles", "Dolares"];
      } else {
        this.currencies = ["Soles", "Dolares", "Soles y Dolares"];
      }
    },
    changeCoin: function changeCoin(val) {
      console.log("val ", val);
    }
  },
  created: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var id, tariff, channels, i, element;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              id = Number(this.$route.params.id);
              _context2.next = 4;
              return this.$store.dispatch("master-data/tariff", id);

            case 4:
              tariff = _context2.sent;


              this.platform = tariff.platform;

              this.channel = tariff.channel;
              this.switchChannel = this.channel === 'No aplica' ? false : true;
              this.selectChannel = this.channel === 'No aplica' ? true : false;

              this.subproduct = tariff.subproduct;
              this.currency = tariff.currency;
              this.affiliation = tariff.affiliation;
              this.switchAffiliation = this.affiliation === 'No aplica' ? false : true;
              this.selectAffiliation = this.affiliation === 'No aplica' ? true : false;

              this.affiliationComment = tariff.affiliationComment;
              this.switchAffiliationComment = this.affiliationComment === 'No aplica' ? false : true;
              this.selectAffiliationComment = this.affiliationComment === 'No aplica' ? true : false;

              this.equipmentCost = tariff.equipmentCost;
              this.switchEquipmentCost = this.equipmentCost === 'No aplica' ? false : true;
              this.selectEquipmentCost = this.equipmentCost === 'No aplica' ? true : false;

              this.equipmentCostComment = tariff.equipmentCostComment;
              this.switchEquipmentCostComment = this.equipmentCostComment === 'No aplica' ? false : true;
              this.selectEquipmentCostComment = this.equipmentCostComment === 'No aplica' ? true : false;

              this.maintenance = tariff.maintenance;
              this.switchMaintenance = this.maintenance === 'No aplica' ? false : true;
              this.selectMaintenance = this.maintenance === 'No aplica' ? true : false;

              this.maintenanceDollar = tariff.maintenanceDollar;
              this.switchMaintenanceDollar = this.maintenanceDollar === 'No aplica' ? false : true;
              this.selectMaintenanceDollar = this.maintenanceDollar === 'No aplica' ? true : false;

              this.maintenanceComment = tariff.maintenanceComment;
              this.switchMaintenanceComment = this.maintenanceComment === 'No aplica' ? false : true;
              this.selectMaintenanceComment = this.maintenanceComment === 'No aplica' ? true : false;

              this.platformUsageCE = tariff.platformUsageCE;
              this.switchPlatformUsageCE = this.platformUsageCE === 'No aplica' ? false : true;
              this.selectPlatformUsageCE = this.platformUsageCE === 'No aplica' ? true : false;

              this.platformUsageCEComment = tariff.platformUsageCEComment;
              this.switchPlatformUsageCEComment = this.platformUsageCEComment === 'No aplica' ? false : true;
              this.selectPlatformUsageCEComment = this.platformUsageCEComment === 'No aplica' ? true : false;

              this.renewal = tariff.renewal;
              this.switchRenewal = this.renewal === 'No aplica' ? false : true;
              this.selectRenewal = this.renewal === 'No aplica' ? true : false;

              this.renewalComment = tariff.renewalComment;
              this.switchRenewalComment = this.renewalComment === 'No aplica' ? false : true;
              this.selectRenewalComment = this.renewalComment === 'No aplica' ? true : false;

              _context2.next = 46;
              return this.$store.dispatch("affiliations/form/consultChannel");

            case 46:
              channels = _context2.sent;

              for (i = 0; i < channels.length; i++) {
                element = channels[i].text;

                this.channels.push(element);
              }
              _context2.next = 53;
              break;

            case 50:
              _context2.prev = 50;
              _context2.t0 = _context2["catch"](0);

              this.$controlMessage(_context2.t0);

            case 53:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this, [[0, 50]]);
    }));

    function created() {
      return _ref2.apply(this, arguments);
    }

    return created;
  }(),

  computed: {
    disabled: function disabled() {
      return this.$v.$invalid;
    }
  },
  watch: {
    switchChannel: function switchChannel(val) {
      if (val) {
        this.selectChannel = false;
        this.channel = "";
      } else {
        this.selectChannel = true;
        this.channel = "No aplica";
      }
    },
    switchAffiliation: function switchAffiliation(val) {
      if (val) {
        this.selectAffiliation = false;
        this.affiliation = "";
      } else {
        this.selectAffiliation = true;
        this.affiliation = "No aplica";
      }
    },
    switchAffiliationComment: function switchAffiliationComment(val) {
      if (val) {
        this.selectAffiliationComment = false;
        this.affiliationComment = "";
      } else {
        this.selectAffiliationComment = true;
        this.affiliationComment = "No aplica";
      }
    },
    switchEquipmentCost: function switchEquipmentCost(val) {
      if (val) {
        this.selectEquipmentCost = false;
        this.equipmentCost = "";
      } else {
        this.selectEquipmentCost = true;
        this.equipmentCost = "No aplica";
      }
    },
    switchEquipmentCostComment: function switchEquipmentCostComment(val) {
      if (val) {
        this.selectEquipmentCostComment = false;
        this.equipmentCostComment = "";
      } else {
        this.selectEquipmentCostComment = true;
        this.equipmentCostComment = "No aplica";
      }
    },
    switchMaintenance: function switchMaintenance(val) {
      if (val) {
        this.selectMaintenance = false;
        this.maintenance = "";
      } else {
        this.selectMaintenance = true;
        this.maintenance = "No aplica";
      }
    },
    switchMaintenanceDollar: function switchMaintenanceDollar(val) {
      if (val) {
        this.selectMaintenanceDollar = false;
        this.maintenanceDollar = "";
      } else {
        this.selectMaintenanceDollar = true;
        this.maintenanceDollar = "No aplica";
      }
    },
    switchMaintenanceComment: function switchMaintenanceComment(val) {
      if (val) {
        this.selectMaintenanceComment = false;
        this.maintenanceComment = "";
      } else {
        this.selectMaintenanceComment = true;
        this.maintenanceComment = "No aplica";
      }
    },
    switchPlatformUsageCE: function switchPlatformUsageCE(val) {
      if (val) {
        this.selectPlatformUsageCE = false;
        this.platformUsageCE = "";
      } else {
        this.selectPlatformUsageCE = true;
        this.platformUsageCE = "No aplica";
      }
    },
    switchPlatformUsageCEComment: function switchPlatformUsageCEComment(val) {
      if (val) {
        this.selectPlatformUsageCEComment = false;
        this.platformUsageCEComment = "";
      } else {
        this.selectPlatformUsageCEComment = true;
        this.platformUsageCEComment = "No aplica";
      }
    },
    switchRenewal: function switchRenewal(val) {
      if (val) {
        this.selectRenewal = false;
        this.renewal = "";
      } else {
        this.selectRenewal = true;
        this.renewal = "No aplica";
      }
    },
    switchRenewalComment: function switchRenewalComment(val) {
      if (val) {
        this.selectRenewalComment = false;
        this.renewalComment = "";
      } else {
        this.selectRenewalComment = true;
        this.renewalComment = "No aplica";
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/tariffs/tariff-detail.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/tariffs/tariff-detail.vue
// module chunks = 18